export enum EMaterialRequirement {
  NEW = "N",
  BOOKING = "B",
  BOOKED = "D",
  PREPARED = "P",
  DELIVERED = "C",
}
